// src/store/AppStore.js
import React, { createContext, useContext, useReducer } from "react";

// 1. Define initial state
const initialState = {
    loading: false,
    actions: {
        setLoading: () => { },
    }
};

// 2. Define action types (constants help avoid typos)
const ActionTypes = {
    SET_LOADING: "SET_LOADING",
};

// 3. Reducer function
function appReducer(state, action) {
    switch (action.type) {
        case ActionTypes.SET_LOADING:
            return { ...state, loading: action.payload };

        default:
            return state;
    }
}

// 4. Create Context
const LoaderContext = createContext(initialState);

// 5. Create Provider
export const LoaderProvider = ({ children }) => {
    const [state, dispatch] = useReducer(appReducer, initialState);

    // Optionally wrap dispatch in actions for cleaner usage
    const actions = {
        setLoading: (loading) => dispatch({ type: ActionTypes.SET_LOADING, payload: loading }),
    };

    return (
        <LoaderContext.Provider value={{ state, actions }}>
            {children}
        </LoaderContext.Provider>
    );
};

// 6. Custom hook for consuming store
export const useLoadingStore = () => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error("useAppStore must be used within an AppProvider");
    }
    return context;
};
